export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'name', label: 'name', sortable: true },
    { key: 'code', label: 'Code', sortable: true },
    { key: 'category_subject', label: 'Category Subject', sortable: true },
    { key: 'is_priority', label: 'Ustuvor', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
  }
}
